angular.module 'app'

  .constant 'config',

    api:
      baseUrl: '/api'


    # http://192.168.5.30:3331/?wechat_id=youwei&group_id=1&openid=o9SPRvi7jWb82ykmEfrKmVfIjezg
    # http://192.168.5.30:3331/?wechat_id=youwei&group_id=1&openid=o9SPRvi7jWb82ykmEfrKmVfIjezg#/authentication_info
    # http://campus-app.ersinfotech.cn/?wechat_id=youwei&group_id=1&openid=o9SPRvi7jWb82ykmEfrKmVfIjezg
